import React from 'react';
import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'white';
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  color = 'primary',
}) => {
  return (
    <div className={`${styles.spinner} ${styles[size]} ${styles[color]}`} />
  );
};

export default Spinner;
